import { uniqueId } from 'lodash';
import { FaCheck } from 'react-icons/fa';
import { FormPart } from 'modules/ScrShopNew/components/Forms/FormPart';

import styled from 'styled-components';

interface ICheckbox extends React.AllHTMLAttributes<HTMLInputElement> {
  // readonly onChange: (e: React.SyntheticEvent<EventTarget>) => void;
  readonly children: React.ReactNode;
  readonly name: string;
  readonly id?: string;
  readonly tick_position?: string;
  readonly type?: string;
  readonly as?: any;
  readonly is_radio?: boolean;
  readonly width?: string;
  readonly errorText?: string;
  readonly display?: string;
}

interface ICheckboxStyled {
  readonly tick_position?: string;
}

interface ILabel extends ICheckboxStyled {
  readonly is_radio?: boolean;
  readonly width?: string;
}

const StyledCheckbox = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const CheckboxStyled = styled.input`
  position: absolute;
  visibility: hidden;
  ${({ tick_position }: ICheckboxStyled) => tick_position}: 0;
  z-index: 0;
  background: #fff;
  border: 1px solid #dedddd;
`;

const Radio = styled.div`
  border: 1px solid #dedddd;
  width: 20px;
  height: 20px;
  background: #fff;
  margin-right: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  pointer-events: none;
  margin-bottom: auto;
  margin-top: 2px;
`;

const Label = styled.label`
  display: flex;
  transition: 0.4s;
  position: relative;
  text-align: left;
  max-width: ${({ width }: ILabel) => width || '100%'};
  box-sizing: border-box;
  width: 100%;
  cursor: pointer;
  align-items: center;
  font-size: 16px;

  svg path {
    fill: transparent;
  }

  ${CheckboxStyled}:disabled + & {
    cursor: default;
  }
  ${CheckboxStyled}:checked + & {
    svg path {
      fill: #000;
    }
  }
`;

export const Checkbox = ({
  onChange,
  children,
  tick_position = 'left',
  type = 'checkbox',
  id = uniqueId('checkbox'),
  width,
  errorText,
  ...rest
}: ICheckbox) => (
  <FormPart errorText={errorText} flexDirection="row">
    <StyledCheckbox>
      <CheckboxStyled
        data-cy="StyledCheckbox"
        onChange={onChange}
        id={id}
        type={type}
        tick_position={tick_position}
        {...rest}
      />
      <Label
        data-cy="component-checkbox"
        htmlFor={id}
        is_radio={type === 'radio'}
        tick_position={tick_position}
        width={width}
      >
        <Radio data-cy="checkbox">
          <FaCheck />
        </Radio>
        {children}
      </Label>
    </StyledCheckbox>
  </FormPart>
);
